import { render, staticRenderFns } from "./PickMultipleContactModal.vue?vue&type=template&id=3589f6fa&scoped=true"
import script from "./PickMultipleContactModal.vue?vue&type=script&lang=ts"
export * from "./PickMultipleContactModal.vue?vue&type=script&lang=ts"
import style0 from "./PickMultipleContactModal.vue?vue&type=style&index=0&id=3589f6fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3589f6fa",
  null
  
)

export default component.exports